module.exports = {
      id: "icone-pix-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#icone-pix",
      toString: function () {
        return this.url;
      }
    }